import tw from "tailwind-styled-components";
import { FaCoins } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

const DuesSummary = ({ duesStats }) => {
    const navigate = useNavigate();
    return (
        <Card>
            <Header>
                <IconWrapper>
                    <FaCoins size={24} className="text-gray-500" />
                </IconWrapper>
                <Title>Dues</Title>
            </Header>
            <TotalAmount className="flex items-center">{'₹' + duesStats.totalPending || 0}</TotalAmount>
            <Subtitle className='cursor-pointer' onClick={() => navigate('/landlord/dues')}>
                Total Dues
                <IoIosArrowForward
                    size={12}
                    className="ml-1 mt-0.5"
                />
            </Subtitle>

            <StatsGrid>
                <StatItem>
                    <StatNumber >{'₹' + duesStats.rentPending || 0}</StatNumber>
                    <StatLabel>Rent </StatLabel>
                </StatItem>
                <StatItem className="lg:col-span-2">
                    <StatNumber >{'₹' + duesStats.securityPending || 0} </StatNumber>
                    <StatLabel>Security </StatLabel>
                </StatItem>
            </StatsGrid>
        </Card>
    );
};

const Card = tw.div`bg-white shadow-md rounded-lg p-6  gap-4`;
const Header = tw.div`flex items-center space-x-3 mb-4`;
const IconWrapper = tw.div`p-3 border border-gray-100 rounded-lg`;
const Title = tw.h3`text-lg font-semibold text-gray-800`;
const TotalAmount = tw.h1`text-4xl font-bold text-rose-500 mt-6`;
const Subtitle = tw.p`text-sm text-gray-500 flex items-center`;
const StatsGrid = tw.div`grid md:grid-cols-3 grid-cols-1 sm:grid-cols-2 mt-10 gap-6`;
const StatItem = tw.div``;
const StatNumber = tw.h4`text-lg font-semibold text-gray-800`;
const StatLabel = tw.p`text-sm text-gray-500`;
const Button = tw.button`rounded-lg md:-mt-1.5 bg-gray-50 p-2 text-sm text-gray-600 hover:text-primary-color flex justify-center items-center`

export default DuesSummary;
